import type { Route } from "../../store/router";

/**
 * 전역 무동작 가드 규칙 — 순수 함수 (IdleGuard.tsx 가 쓴다; 대소문자만 다른 파일명은 macOS 에서 충돌해 Rules 접미사).
 * 완료 단계 전 화면에서 손님이 자리를 비우면 경고(카운트다운) 뒤 처음으로 돌아간다.
 * 예전엔 동의·촬영 확인·자막 화면이 각자 120초 뒤 예고 없이 리셋했다 — 한 곳으로 모으고 예고를 넣었다 (2026-10-21).
 */
export const IDLE_WARN_MS = 120_000;
export const IDLE_COUNTDOWN_MS = 30_000;

/**
 * 가드를 켜는 화면. 빠지는 화면과 이유:
 *  attract(이미 처음) · thanks(자체 카운트다운) · payment(손님이 폰으로 결제 중 — 결제 만료는 서버가 정함)
 *  · printShare(QR 찍고 떠남 → 자체 120초 뒤 thanks) · print(인쇄 대기 → 자체 120초 리셋)
 */
export const IDLE_GUARD_ROUTES: readonly Route[] = [
  "themeSelect", "styleSelect", "consent", "preview", "generate", "review",
  "videoIntro", "videoMotions", "videoCaption", "videoGenerate",
];

export function idleGuardActive(route: Route): boolean {
  return IDLE_GUARD_ROUTES.includes(route);
}

export type IdlePhase =
  | { kind: "active" }
  | { kind: "warning"; remainingSec: number }
  | { kind: "expired" };

/** 마지막 입력 뒤 흐른 시간 → 단계. 경고 중 남은 초는 올림(30 → … → 1), 0 이 되는 순간 expired. */
export function idlePhase(idleMs: number, warnMs = IDLE_WARN_MS, countdownMs = IDLE_COUNTDOWN_MS): IdlePhase {
  if (idleMs < warnMs) return { kind: "active" };
  const left = warnMs + countdownMs - idleMs;
  if (left <= 0) return { kind: "expired" };
  return { kind: "warning", remainingSec: Math.ceil(left / 1000) };
}
